<template>
  <div class="dropdown" :class="[positionClass, { opened: isShow }]">
    <div
      class="dropdown-button"
      :class="{ 'with-toggle': withArrow }"
      @click="toggle"
      ref="openButton"
      type="button"
    >
      <span v-if="withArrow" class="dropdown-toggle"></span>
      <slot name="buttonText"></slot>
    </div>
    <div class="dropdown-menu" :class="[{ show: isShow }, { large: isLarge }]" @click="onMenuClick">
      <slot name="dropdownContent"></slot>
    </div>
  </div>
</template>

<script>
import '@/styles/components/dropdown.less'

export default {
  name: 'BaseDropdown',
  props: {
    position: {
      type: String,
      required: false,
      default: 'down',
      validator: value => {
        return ['down', 'left', 'right', 'up'].indexOf(value) !== -1
      }
    },
    withArrow: {
      type: Boolean,
      required: false,
      default: true
    },
    closeByMenuClick: {
      type: Boolean,
      default: false
    },
    isLarge: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isShow: false
  }),
  computed: {
    positionClass() {
      switch (this.position) {
        case 'left':
          return 'dropleft'
        case 'right':
          return 'dropright'
        case 'up':
          return 'dropup'
        default:
          return ''
      }
    }
  },
  created() {
    const $root = this.$root

    $root.$on('close-dropdown', this.close)

    if (!$root['has-dropdown']) {
      Object.defineProperty($root, 'has-dropdown', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: true
      })
      document.onclick = e => {
        const target = e.target
        const dropdown =
          target.closest('.dropdown-button') ||
          target.closest('.dropdown-menu') ||
          target.closest('.dropdown')
        if (!dropdown) {
          $root.$emit('close-dropdown')
        }
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === from.path) {
        return
      }
      this.close()
    }
  },
  methods: {
    close() {
      this.isShow = false
    },
    toggle() {
      this.isShow = !this.isShow
    },
    onMenuClick() {
      if (this.closeByMenuClick) {
        this.close()
      }
    }
  }
}
</script>
